import { AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage } from 'element-plus'
import qs from 'qs'
import { TRANSFORM_REQUEST_DATA } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { objToFormData } from '@/utils'

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data'
  ) {
    config.data = objToFormData(config.data)
  }
  if (config.method === 'get' && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      if (config.params[key] !== void 0 && config.params[key] !== null) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  return config
}
const SKIP_CODES = [0, 904, -11]
const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === 'blob') {
    // 检查响应头中的Content-Type来判断是否为错误信息
    const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
    
    // 如果Content-Type是JSON相关，说明是错误信息
    if (contentType.includes('application/json') || contentType.includes('text/json')) {
      const fileReader: any = new FileReader()
      fileReader.readAsText(new Blob([response.data]), 'utf-8')
      fileReader.onload = function () {
        try {
          const fileRes = JSON.parse(fileReader.result)
          if (fileRes.code !== 0) {
            ElMessage.error(fileRes.msg || '下载失败')
          }
        } catch (error) {
          console.log('JSON解析失败，可能是格式错误')
        }
      }
    }
    // 如果是文件类型（如excel、pdf等），直接返回，不进行JSON解析
    return response
  } else if (SKIP_CODES.includes(response.data.code)) {
    return response.data
  } else {
    ElMessage.error(response?.data?.msg)
    if (response?.data?.code === -5) {
      // 登录失效
      const userStore = useUserStoreWithOut()
      userStore.logout()
    } else {
      return response.data
    }
  }
}

export { defaultResponseInterceptors, defaultRequestInterceptors }
